var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWholeSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 146,
    viewBox: "0 0 194 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.60791,
    width: 193.167,
    height: 145,
    rx: 10,
    fill: "#1E2631"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2368 28C80.7384 28 78.7129 30.0147 78.7129 32.5C78.7129 34.9853 80.7384 37 83.2368 37H110.38C112.879 37 114.904 34.9853 114.904 32.5C114.904 30.0147 112.879 28 110.38 28H83.2368Z",
    fill: "#363E4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8087 118C116.797 118 133 101.882 133 82C133 73.6808 130.163 66.0205 125.4 59.9246L131.675 53.682C133.442 51.9246 133.442 49.0754 131.675 47.318C129.909 45.5607 127.044 45.5607 125.277 47.318L119.001 53.5606C112.873 48.8219 105.172 46 96.8087 46C76.8207 46 60.6172 62.1177 60.6172 82C60.6172 101.882 76.8207 118 96.8087 118ZM96.8087 109C111.8 109 123.952 96.9117 123.952 82C123.952 67.0884 111.8 55 96.8087 55C81.8177 55 69.6651 67.0884 69.6651 82C69.6651 96.9117 81.8177 109 96.8087 109Z",
    fill: "#363E4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8091 64C99.3077 64 101.333 66.0147 101.333 68.5V82C101.333 84.4853 99.3077 86.5 96.8091 86.5C94.3105 86.5 92.2852 84.4853 92.2852 82V68.5C92.2852 66.0147 94.3105 64 96.8091 64Z",
    fill: "#2FF29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholeSale);
export default __webpack_public_path__ + "static/media/WholeSale.09235ec92861573eebaad79a02e98a7a.svg";
export { ForwardRef as ReactComponent };